import React, { useEffect } from 'react';
import { Container, Typography, Button, Box } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const HomePage = () => {
  const { currentUser, loginWithGoogle } = useAuth();

  const navigate = useNavigate();

  useEffect(() => {
    if (currentUser && currentUser.role === 'master' && currentUser.firstLogin) {
      navigate('/new-company', { replace: true });
    }
  }, [currentUser, navigate]);

  return (
    <Container maxWidth="md" sx={{ pt: 20, pb: 20, textAlign: 'center' }}>

      <Typography variant="h2" fontWeight={800} gutterBottom>
        Bem-vindo ao ERP para Escritórios de Arquitetura
      </Typography>

      <Typography variant="h6" color="text.secondary">
        Gerencie projetos, clientes, usuários e fluxo de caixa com uma interface simples e elegante.
      </Typography>

      {currentUser ? (
        <Box>
          <Typography variant="h6" sx={{ mb: 3 }}>
            Olá, {currentUser.displayName || currentUser.email}
          </Typography>
          <Typography variant="h6" color="text.secondary">
            Faça sua primeira precificação
          </Typography>
          <Button
            variant="contained"
            color="primary"
            size="large"
            sx={{ borderRadius: 3, mr: 2 }}
            onClick={() => navigate('/pricing/new')}
          >
            Ir para Precificação
          </Button>
        </Box>
      ) : (
        <Button
          variant="contained"
          size="large"
          onClick={loginWithGoogle}
          sx={{ borderRadius: 3 }}
        >
          Login com Google
        </Button>
      )}
    </Container>
  );
};

export default HomePage;
